import { TimeRange } from 'types'
import { extendRangeToUtcDayLimits } from 'utils/time/extendRangeToUtcDayLimits'

export const getDefaultTimeRangeParams = (): TimeRange => {
  return extendRangeToUtcDayLimits({ to: Date.now(), from: Date.now() })
}
